import {en} from '../langs/eng'
import {sp} from '../langs/spa'

export function selectdLocale(lang) {
    if (lang === 'en'){
        return en
    } else {
        return sp
    }
}